<template>
  <CdrAccordionGroup
    data-ui="resource"
  >
    <CdrAccordion
      v-for="(resource, index) in mappedResources"
      :id="resource.id"
      :key="resource.id"
      :opened="resource.opened"
      level="3"
      class="resource__item"
      @accordion-toggle="toggleItem(index)"
    >
      <template #label>
        {{ resource.title }}
      </template>
      <div
        class="resource__content"
        v-html="resource.content"
      />
    </CdrAccordion>
  </CdrAccordionGroup>
</template>

<script>
import convertToHtml from '@rei/rich-text-renderer';
import { CdrAccordion, CdrAccordionGroup } from '@rei/cedar';

export default {
  name: 'ResourceSectionComponent',
  components: {
    CdrAccordion,
    CdrAccordionGroup,
  },
  props: {
    resourceSections: {
      type: Array,
      required: false,
      default() { return []; },
    },
    graphqlEnabled: {
      type: Boolean,
      default: false,
      required: false,
    },
  },
  data() {
    return {
      mappedResources: this.resourceSections.map((resource, index) => {
        const content = this.graphqlEnabled ? convertToHtml(resource.content) : resource.content;

        return {
          title: resource.title,
          content,
          id: `resource-${index}`,
          opened: false,
        };
      }),
    };
  },
  methods: {
    toggleItem(index) {
      this.mappedResources[index].opened = !this.mappedResources[index].opened;
    },
  },
};
</script>

<style lang="scss">

.resource__item li {
  list-style-type: disc;
}

</style>
